import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SeasonProcessState, SeasonTypeEnum } from '@coin/shared/core/util-enums';
import { SeasonPlan } from '@coin/shared/core/util-models';
import { ToastrService } from 'ngx-toastr';
import { Season } from '@coin/shared/season-mgmt/util';
import { SeasonSimulation } from '../models/season-simulation.model';
import { SeasonState } from '../store/season.state';

@Injectable({
  providedIn: 'root'
})
export class ProcessNavigationService {
  private readonly seasonState = inject(SeasonState);
  private readonly router = inject(Router);
  private readonly toast = inject(ToastrService);

  get currentSeason(): Season {
    return this.seasonState.currentSeason();
  }

  get currentPlan(): SeasonPlan {
    return this.seasonState.currentPlan();
  }

  get currentSim(): SeasonSimulation {
    return this.seasonState.currentSimulation();
  }

  get seasonType(): SeasonTypeEnum {
    return [SeasonTypeEnum.SpecialPaymentCash, SeasonTypeEnum.SpecialPaymentEquity].includes(
      this.currentSeason.seasonType
    )
      ? SeasonTypeEnum.SpecialPayment
      : this.currentSeason.seasonType;
  }

  nextProcessStep(): void {
    const nextStep = this.seasonState.nextProcessStep();
    this.navigate(nextStep);
  }

  prevProcessStep(): void {
    const prevStep = this.seasonState.prevProcessStep();
    this.navigate(prevStep);
  }

  goToStep(id: string): void {
    const step = this.seasonState.getProcessStepById(id)();
    if (step) {
      this.navigate(step);
    }
  }

  navigate(step: { route: string; id?: SeasonProcessState }): void {
    if (!step?.route || !this.currentSeason?.id) {
      this.toast.error('Cannot open season.');
      return;
    }

    const noSeasonIdParam = step?.id === SeasonProcessState.SeasonOverview;

    this.router.navigate([step.route], {
      queryParams: {
        seasonId: !noSeasonIdParam ? this.currentSeason.id : undefined,
        planId:
          !this.currentPlan?.id || step.id === SeasonProcessState.PlanManagement ? undefined : this.currentPlan.id,
        simId:
          !this.currentSim?.id || step.id === SeasonProcessState.SimulationManagement ? undefined : this.currentSim.id,
        type: this.seasonType
      }
    });
  }
}
